import { Navigate } from 'react-router-dom';
import PrivateRoute from 'utils/privateRoute';
import Overview from 'components/FineOps/overview';
import ExecutiveDashboard from 'components/FineOps/executive-dashboard';
import ProgramSummary from 'components/FineOps/program';
import DetailsSummary from 'components/FineOps/details';
import ResourceMapping from 'components/FineOps/ResourceMapping';
import ProgramList from 'components/FineOps/ResourceMapping/programs';
import ProgramDetails from 'components/FineOps/ResourceMapping/programDetails';
import ProjectDetails from 'components/FineOps/ResourceMapping/projectDetails';
import CloudSpendFinOpsReport from 'components/FineOps/CloudSpendFinOpsReport';
import PreAop2027Report from 'components/FineOps/PreAop2027Report';
import EDFCostOverview from 'components/FineOps/EDFCostOverview';
import Dissection2026 from 'components/FineOps/2026Dissection';


const FinOpsRoutes = [
	{
		key: 'fin_oview',
		route: '/finops/overview',
		component: (
			<PrivateRoute
				Component={Overview}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_dest_exec_dash',
		route: '/finops/executive-dashboard',
		component: (
			<PrivateRoute
				Component={ExecutiveDashboard}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_dest_oview',
		route: '/dataestate/financialOverview',
		component: (
			<PrivateRoute
				Component={ExecutiveDashboard}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_prgrm',
		route: '/finops/program',
		component: (
			<PrivateRoute
				Component={ProgramSummary}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_dest_prgm',
		route: '/dataestate/financialProgram',
		component: (
			<PrivateRoute
				Component={ProgramSummary}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_exec_dash',
		route: '/finops/resourcemapping/search',
		component: (
			<PrivateRoute
				Component={ResourceMapping}
				restrictedRoles={[]}
			/>
		)
	},
	{
		key: 'fin_res_programs',
		route: '/finops/resourcemapping/programs',
		component: (
			<PrivateRoute
				Component={ProgramList}
				restrictedRoles={[]}
			/>
		)
	},
	{
		key: 'fin_res_projects',
		route: '/finops/resourcemapping/programs/:id/:name',
		component: (
			<PrivateRoute
				Component={ProgramDetails}
				restrictedRoles={[]}
			/>
		)
	},
	{
		key: 'fin_res_prj_id_prgm_proj',
		route: '/finops/resourcemapping/projects/:programId/:projectId/:program/:project',
		component: (
			<PrivateRoute
				Component={ProjectDetails}
				restrictedRoles={[]}
			/>
		)
	},
	{
		key: 'fin_res_map',
		route: '/finops/details',
		component: (
			<PrivateRoute
				Component={DetailsSummary}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_exec_dash',
		route: '/dataestate/financialDetails',
		component: (
			<PrivateRoute
				Component={DetailsSummary}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_cost_dash_redirect',
		route: '/finops/resourcemapping/costsummary',
		component: <Navigate to="/finops/executive?tab=3" replace />
	},
	{
		key: 'fin_cloud_spend_report',
		route: '/finopsExecutive/cloud-spend-report',
		component: (
			<PrivateRoute
				Component={CloudSpendFinOpsReport}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_edf_cost_overview',
		route: '/finopsExecutive/edf-cost-overview',
		component: (
			<PrivateRoute
				Component={EDFCostOverview}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_pre_aop_2027',
		route: '/finopsExecutive/pre-aop-2027',
		component: (
			<PrivateRoute
				Component={PreAop2027Report}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	},
	{
		key: 'fin_2026_dissection',
		route: '/finopsExecutive/2026-dissection',
		component: (
			<PrivateRoute
				Component={Dissection2026}
				restrictedRoles={['Platform Operations Admin/SRE', 'Data Operations Admin', 'Data Operations User']}
			/>
		)
	}
];

export default FinOpsRoutes;
